import Vue from 'vue';
import initRepository from '@/repositories/fo-manual-API/Repository';
import App from './App.vue';
import './filters';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

new Vue({
  beforeCreate() {
    this.$store.commit('INITIALISE_STORE');
  },
  created() {
    initRepository(store);
  },
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
